import * as $ from 'jquery';
import 'magnific-popup';

$('body').magnificPopup({
  delegate: '.ajax-popup-link',
  type: 'ajax',
  overflowY: 'scroll',
  closeOnContentClick: false,
  closeOnBgClick: false,
  showCloseBtn: true,
  closeMarkup: '<svg class="modal-close sprite-icon sprite-search-close-icon"><use xlink:href="#sprite-search-close"/></svg>',
  callbacks: {},
});

$('body').on('click', '.modal-close', () => {
  $.magnificPopup.close();
});

$(document).ready(function() {
  // Handle opening the modal
  $('#orderNowModal').on('click', function(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    var $modal = $('#product-modal');
    $modal.show();
  });

  // Handle closing the modal
  $('.product-modal-close').on('click', function() {
    $('#product-modal').hide();
  });
});
